/* 上财果团团 */

export default class Version {

    static code = 7
    static tag = "1.0.1-1"

    /**
     * 构建时间。遵循 ISO8601 格式。
     */
    static buildTime = '2024-11-21T20:48+08:00'

    private constructor() {}
}
